import {Box, Typography} from '@mui/material';
import {FC} from 'react';
import {
    cardSx,
    factLabelSx,
    factSx,
    factValueSx,
    factsSx,
    headSx,
    identitySx,
    personBadgeSx,
    statusSx,
    subtitleSx,
    thingBadgeSx,
    titleSx,
} from './RecordIdentityCard.sx';
import {RecordIdentityCardProps} from './RecordIdentityCard.types';

/**
 * What this record is, in one card, on a phone.
 *
 * Six record pages open with the same four things - a badge, a name, a line of context and a status -
 * over the facts the page already states, so they are drawn once here rather than six times. What
 * each page passes is its own: its glyph, its own status pill with its own colours, and the facts it
 * had already formatted. Nothing is computed here, which is what keeps money, dates and energy
 * reading exactly as they do on a desktop.
 */
export const RecordIdentityCard: FC<RecordIdentityCardProps> = ({
                                                                   icon,
                                                                   person = false,
                                                                   title,
                                                                   subtitle,
                                                                   status,
                                                                   facts,
                                                               }) => (
    <Box sx={cardSx}>
        <Box sx={headSx}>
            <Box sx={person ? personBadgeSx : thingBadgeSx}>{icon}</Box>
            <Box sx={identitySx}>
                <Typography sx={titleSx}>{title}</Typography>
                {subtitle && <Typography sx={subtitleSx}>{subtitle}</Typography>}
            </Box>
            {status && <Box sx={statusSx}>{status}</Box>}
        </Box>

        {facts.length > 0 && (
            <Box sx={factsSx}>
                {facts.map((fact) => (
                    <Box
                        key={fact.id}
                        sx={factSx}
                    >
                        <Typography sx={factLabelSx}>{fact.label}</Typography>
                        <Typography
                            component="div"
                            sx={factValueSx}
                        >
                            {fact.value}
                        </Typography>
                    </Box>
                ))}
            </Box>
        )}
    </Box>
);
